import React, { FC, useState } from "react";
import Tabs from "@mui/material/Tabs";
import Psychiatric from "./Tabs/Psychiatric";
import Tab from "@mui/material/Tab";
import { Wrapper } from "../styled";

const psyhiatricTabs = [
  {
    title: "Психиатрическое освидетельствование",
    component: <Psychiatric/>,
  }
];


const PsychiatricExamination: FC = () => {
  const [tab, setTab] = useState(0);

  const handleChangeTab = (event: React.SyntheticEvent, newValue: number) => {
    setTab(newValue);
  };

  return (
    <Wrapper>
      <Tabs
        value={tab}
        onChange={handleChangeTab}
        variant="scrollable"
        scrollButtons="auto"
        aria-label="scrollable auto tabs example"
      >
        {psyhiatricTabs.map((tab) => (
          <Tab key={tab.title} label={tab.title} />
        ))}
      </Tabs>
      {psyhiatricTabs[tab].component}
    </Wrapper>
  );
};

export default PsychiatricExamination;
